import { render, staticRenderFns } from "./EditFitnessPlanItemModal.vue?vue&type=template&id=b03a1f70&"
import script from "./EditFitnessPlanItemModal.vue?vue&type=script&lang=js&"
export * from "./EditFitnessPlanItemModal.vue?vue&type=script&lang=js&"
import style0 from "./EditFitnessPlanItemModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports